import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SkorList from "../tenant-profile/skorList";
import { isAdminLoggedIn } from "../../Utils/adminLogin";

const AdminTenantView = () => {
  const { tenantid } = useParams();
  const navigate = useNavigate();
  const [originalUserType, setOriginalUserType] = useState(null);

  useEffect(() => {
    // Check if user is logged in as admin
    if (!isAdminLoggedIn()) {
      // Store the attempted path for redirect after admin login
      localStorage.setItem("admin_redirect_path", window.location.pathname);
      navigate("/home");
      return;
    }

    // Store original user type and set to admin for llShowOnly logic
    const originalType = localStorage.getItem("usertype");
    setOriginalUserType(originalType);
    localStorage.setItem("usertype", "admin");

    // Cleanup: restore original user type when component unmounts
    return () => {
      if (originalType) {
        localStorage.setItem("usertype", originalType);
      }
    };
  }, [tenantid, navigate]);

  const handleGoBack = () => {
    // Restore original user type before navigating
    if (originalUserType) {
      localStorage.setItem("usertype", originalUserType);
    }
    navigate("/home");
  };

  return (
    <>
      {/* Use SkorList component for detailed tenant profile view */}
      <SkorList
        showReportIcons={true}
        setUserMaxRent={() => {}}
        adminTenantId={tenantid}
      />
    </>
  );
};

export default AdminTenantView;
